<template>
    <div>
        <div class="row" v-if="contratos">
            <div class="col-md-4"  style="margin-bottom:30px;">
                <div class="list-group alert alert-success" style=" min-height:253px; padding:15px; text-alig:center. display:flex; align-items:center; justify-content:center;">
                    <i class="i-rounded i-xlarge icon-line-circle-plus" style="background:none;color: #28a745; float:none;"></i>
                    <router-link class="btn btn-success" :to="`/areacliente/1/contratar`">CONTRATAR SERVIÇO</router-link>
                </div>
            </div>
            <div class="col-md-4"  style="margin-bottom:30px;" v-for="(contrato,i) in contratos" :key="i">
                <ul class="list-group">
                    <li class="list-group-item" :class="contrato.tsReprovacao && contrato.status == 'Dados reprovados'? 'list-group-item-danger':''">
                       <h4 class="mb-0">{{contrato.servicos.abreviacao}} - {{contrato.servicos.titulo}}</h4>
                       <small>{{contrato.codigoContratacao}}</small>
                       <hr>
                       <p class="mb-1">Status: <b>{{contrato.status}}</b></p>
                       <p class="mb-1">Etapas Concluídas <span class="badge badge-secondary float-right" style="margin-top: 3px;">{{contrato.etaparealizadas}}/13</span></p>
                       <p class="mb-1 small">Contratacao: <b>{{formataData(contrato.tsContratacao)}}</b></p>
                       <p></p>
                       <router-link class="btn btn-success" v-if="contrato.pago"  :to="`/areacliente/contrato/etapa${contrato.etapa}/${contrato.codigoContratacao}`">Acessar</router-link>
                       <router-link class="btn btn-info" v-else  :to="`/areacliente/1/contratar`">Efetuar pagamento</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                contratos:{},
                etapas:{},
            }
        },
        mounted() {
            this.fnContrato()
        },
        methods: {
            async fnContrato(){
                await this.$http.get('contratacao/lista')
                .then(res=>{
                    this.contratos = res.data
                for (var i =0; i < res.data.length; i++)
                {
                    var etapa = 13;
                    var c = 0;
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa13){etapa = 13}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa12){etapa = 12}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa11){etapa = 11}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa10){etapa = 10}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa09){etapa = 9}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa08){etapa = 8}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa07){etapa = 7}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa06){etapa = 6}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa05){etapa = 5}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa04){etapa = 4}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa03){etapa = 3}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa02){etapa = 2}
                    if(!res.data[i].contratacoesEVOEtapas[0].etapa01){etapa = 1}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa13){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa12){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa11){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa10){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa09){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa08){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa07){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa06){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa05){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa04){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa03){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa02){c++}
                    if(res.data[i].contratacoesEVOEtapas[0].etapa01){c++}
                    this.contratos[i].etapa = etapa
                    this.contratos[i].etaparealizadas = c
                    
                }

                })
                .catch(()=>{})
            },
            formataData(value) {
            return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
            }, 
            addToObject (obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }

                return temp;

            },
            filtraAtivos(){

            }
        },
    }
</script>

<style lang="scss" scoped>

</style>